export default __webpack_public_path__ + "static/media/WAL.41d4c63f.png";